import { useState } from "react";
import {
  CLIENT_LINK_RELATION_LABELS_RU,
  type ClientLinkRelation,
} from "@mnp/shared";
import { Icon } from "../../components/Icon";
import { useClientLinks, useRemoveClientLink } from "../../lib/useClients";
import { LinkClientModal } from "./LinkClientModal";

function relationLabel(relation: string): string {
  return (
    CLIENT_LINK_RELATION_LABELS_RU[relation as ClientLinkRelation] ?? relation
  );
}

export function ClientLinksTab({
  clientId,
  onOpenClient,
}: {
  clientId: string;
  onOpenClient?: (id: string) => void;
}) {
  const { data, isLoading } = useClientLinks(clientId);
  const removeLink = useRemoveClientLink(clientId);
  const [modalOpen, setModalOpen] = useState(false);
  const links = data ?? [];

  return (
    <>
      <div className="cd-links">
        <div className="cd-links-head">
          <p className="cd-links-title">Связь с другими клиентами</p>
          <button
            className="cd-links-add-mini"
            title="Добавить связь"
            onClick={() => setModalOpen(true)}
          >
            <Icon name="plus" size={12} /> Привязать клиента
          </button>
        </div>

        {isLoading ? (
          <p className="muted">Загрузка…</p>
        ) : links.length === 0 ? (
          <div className="cd-links-empty-body">
            <span className="cd-links-empty-icon">🔗</span>
            <p className="cd-links-empty-text">Пусто — связей не задано</p>
          </div>
        ) : (
          <div className="cd-links-grid">
            {links.map((l) => (
              <div key={l.id} className="cd-link-card">
                <button
                  className="cd-link-meta"
                  onClick={() => onOpenClient?.(l.toChatId)}
                  title="Открыть карточку"
                >
                  <div className="cd-link-row1">
                    <span className="cd-link-name mono">{l.toChatId}</span>
                    <span className="cd-link-relation">
                      {relationLabel(l.relation)}
                    </span>
                  </div>
                </button>
                <button
                  className="btn-admin ghost sm"
                  aria-label="Удалить связь"
                  disabled={removeLink.isPending}
                  onClick={() => removeLink.mutate(l.id)}
                >
                  <Icon name="trash" size={14} />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {modalOpen && (
        <LinkClientModal
          currentClientId={clientId}
          existingLinkIds={links.map((l) => l.toChatId)}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
}
